import React, {useCallback, useEffect, useState} from 'react'
import {DateTime} from "luxon";
import {InspectService} from "../../interfaces";
import VehicleInformation from "./VehicleInformation";
import SelectService from "./SelectService/SelectService";
import SelectInspectionTime from "./SelectInspectionTime";
import AskUserInfo from "./AskUserInfo";
import {InfoSubmitEvent} from "../../Containers/RootContainer";
import ReservationReady from "./ReservationReady";
import ReservationActions from "../../Redux/reservationRedux";
import {useDispatch, useSelector} from "react-redux";
import ReservationDone from "./ReservationDone";
import {ServiceCardType} from "./Types";
import {RootState} from "../../Redux";
import Payment from './Payment/Payment'
import MoveToWorkQueue from './MoveToWorkQueue/MoveToWorkQueue'

interface NewReservationProps {
    registrationNumber: string
    isDriveIn: boolean
    hasOtherReservation: boolean
    setServiceCard: (serviceCard: ServiceCardType) => void
    onBack: () => void
    currentServiceCard?: ServiceCardType
}

export const NewReservation= ({
    registrationNumber,
    isDriveIn,
    hasOtherReservation,
    setServiceCard,
    onBack,
    currentServiceCard
}: NewReservationProps) => {
    const dispatch = useDispatch()

    const campaignCode = ""

    const afterInspectionProductId = useSelector((state: RootState) => state.reservation?.registerInfo?.afterInspectionProductId)
    const customerInfo = useSelector((state: RootState) => state.ui.customer)

    const [paymentStep, setPaymentStep] = useState({active: false, method: undefined})

    const handlePayment = useCallback((method: string | null) => {
        setPaymentStep({active: method !== null, method})
    }, [])

    const backFromPayment = () => {
        setPaymentStep({active: false, method: undefined})
    }

    const [date, setDate] = useState<DateTime>()
    const [timeIsSet, setTimeIsSet] = useState(false)
    const [registerInfoShown, setRegisterInfoShown] = useState(false)
    const [service, setService] = useState<InspectService|null>(null)
    const [info, setInfo] = useState<InfoSubmitEvent>()
    const [infoIsSet, setInfoIsSet] = useState(false)
    const [serviceCard, setServiceCardState] = useState<ServiceCardType | null>(currentServiceCard)

    useEffect(() => {
        if (serviceCard !== undefined) {
            setRegisterInfoShown(true)
        }
    }, [serviceCard]);

    function setCurrentServiceCard(serviceCard: ServiceCardType) {
        setServiceCard(serviceCard)
        setServiceCardState(serviceCard)
    }

    function handleContinueToServiceSelection() {
        setRegisterInfoShown(true)
    }

    function setSelectedDate(date: DateTime) {
        setDate(date)
        setTimeIsSet(true)
        if (customerInfo?.token) {
            onSubmitInfo({
                acceptTermsOfUse: true,
                firstName: customerInfo?.name,
                lastName: '',
                language: null,
                email: null,
                phone: null,
                postOffice: null,
                postalCode: null,
                reminder: {
                    emailMessage: false,
                    txtMessage: false,
                },
                offer: {
                    emailMessage: false,
                    txtMessage: false,
                },
                postalAddress: null,
            })
        }
    }

    function setSelectedService(service: InspectService) {
        setService(service)
        setDate(undefined)
        setTimeIsSet(false)
    }

    function onSubmitInfo(info: InfoSubmitEvent) {
        dispatch(ReservationActions.setInformation(info))
        setInfo(info)
        setInfoIsSet(true)
    }

    const selectServiceBack = () => {
        setRegisterInfoShown(false)
    }

    return (
        <>
            {paymentStep.active === false && registerInfoShown === false &&
                <VehicleInformation
                    registrationNumber={registrationNumber}
                    handleContinue={handleContinueToServiceSelection}
                    onBack={onBack}
                    hasOtherReservation={hasOtherReservation}
                />
            }
            {paymentStep.active === false && registerInfoShown && service === null && <>
                <SelectService
                    isDriveIn={isDriveIn}
                    campaignCode={campaignCode}
                    afterInspectionProductId={afterInspectionProductId}
                    handlePayment={handlePayment}
                    serviceCard={serviceCard}
                    setServiceCard={setCurrentServiceCard}
                    setSelectedService={setSelectedService}
                    onBack={selectServiceBack}
                />
            </>}
            {paymentStep.active === false && registerInfoShown && service !== null && <>
                {timeIsSet === false &&
                    <SelectInspectionTime
                        campaignCode={campaignCode}
                        service={service}
                        selectedDate={date}
                        setSelectedDate={setSelectedDate}
                        onBack={() => setService(null)}
                    />
                }
                {timeIsSet === true && <>
                    {infoIsSet === false &&
                        <AskUserInfo
                            prefill={info}
                            onSubmitInfo={onSubmitInfo}
                            onBack={() => setTimeIsSet(false)}
                        />
                    }
                    {infoIsSet === true && paymentStep.method === undefined &&
                        <ReservationReady
                            registrationNumber={registrationNumber}
                            date={date}
                            serviceType={service.name}
                            handleToPayment={handlePayment}
                            setServiceCard={setCurrentServiceCard}
                            serviceCard={serviceCard}
                            onBack={() => setInfoIsSet(false)}
                        />
                    }
                    {infoIsSet === true && paymentStep.method !== undefined &&
                        <ReservationDone serviceCard={serviceCard}/>
                    }
                </>}
            </>}
            {paymentStep.active === true && <>
                {paymentStep.method === 'paymentNotRequired' && serviceCard?.sale?.remainingPrice?.vatIncluded === 0 ?
                    <MoveToWorkQueue serviceCard={serviceCard}/>
                    :
                    <Payment
                        serviceCard={serviceCard}
                        setServiceCard={setCurrentServiceCard}
                        initialPayWithCard={paymentStep.method === 'payWithCard' ? true : (paymentStep.method === 'payOnline' ? false : null)}
                        driveIn={isDriveIn}
                        onBack={backFromPayment}
                    />
                }
            </>}
        </>
    )
}
